import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost, AxiosPatch, AxiosDelete } from '../../../utils/axios';
import * as actions from './spawnActions';

// Create Spawn
function* createSpawn(action) {
  try {
    const result = yield call(AxiosPost, '/mycore/spawn/add/', action.payload);
    yield put(actions.createSpawnSuccess(result.data));
  } catch (e) {
    yield put(actions.createSpawnFailure(e.response?.data?.error || e.message));
  }
}

// Update Spawn
function* updateSpawn(action) {
  try {
    const { id, data } = action.payload;
    const result = yield call(AxiosPatch, `/mycore/${id}/spawn/update/`, data);
    yield put(actions.updateSpawnSuccess(result.data));
  } catch (e) {
    yield put(actions.updateSpawnFailure(e.response?.data?.error || e.message));
  }
}

// Delete Spawn
function* deleteSpawn(action) {
  try {
    const id = action.payload;
    yield call(AxiosDelete, `/mycore/${id}/spawn/delete/`);
    yield put(actions.deleteSpawnSuccess(id));
  } catch (e) {
    yield put(actions.deleteSpawnFailure(e.response?.data?.error || e.message));
  }
}

// Get Spawns by Organization
function* getSpawnsByOrg(action) {
  try {
    const organizationId = action.payload;
    const result = yield call(AxiosCall, `/mycore/${organizationId}/spawn/by-org/`);
    yield put(actions.getSpawnsByOrgSuccess(result.data));
  } catch (e) {
    yield put(actions.getSpawnsByOrgFailure(e.response?.data?.error || e.message));
  }
}

// Toggle Contamination
function* toggleSpawnContamination(action) {
  try {
    const { id, contaminationFree } = action.payload;
    const result = yield call(AxiosPatch, `/mycore/${id}/spawn/toggle-contamination/`, {
      contamination_free: contaminationFree,
    });
    yield put(actions.toggleSpawnContaminationSuccess(result.data));
  } catch (e) {
    yield put(actions.toggleSpawnContaminationFailure(e.response?.data?.error || e.message));
  }
}

// Toggle Active
function* toggleSpawnActive(action) {
  try {
    const { id, active } = action.payload;
    const result = yield call(AxiosPatch, `/mycore/${id}/spawn/toggle-active/`, {
      active,
    });
    yield put(actions.toggleSpawnActiveSuccess(result.data));
  } catch (e) {
    yield put(actions.toggleSpawnActiveFailure(e.response?.data?.error || e.message));
  }
}

// Toggle Depletion
function* toggleSpawnDepletion(action) {
  try {
    const { id, isDepleted } = action.payload;
    const result = yield call(AxiosPatch, `/mycore/${id}/spawn/toggle-depletion/`, {
      is_depleted: isDepleted,
    });
    yield put(actions.toggleSpawnDepletionSuccess(result.data));
  } catch (e) {
    yield put(actions.toggleSpawnDepletionFailure(e.response?.data?.error || e.message));
  }
}

// Get Spawn Detail
function* getSpawnDetail(action) {
  try {
    const id = action.payload;
    const result = yield call(AxiosCall, `/mycore/${id}/spawn/detail/`);
    yield put(actions.getSpawnDetailSuccess(result.data));
  } catch (e) {
    yield put(actions.getSpawnDetailFailure(e.response?.data?.error || e.message));
  }
}

// Get Spawn Lineage
function* getSpawnLineage(action) {
  try {
    const id = action.payload;
    const result = yield call(AxiosCall, `/mycore/${id}/spawn/lineage/`);
    yield put(actions.getSpawnLineageSuccess(result.data));
  } catch (e) {
    yield put(actions.getSpawnLineageFailure(e.response?.data?.error || e.message));
  }
}

// Root Saga
export default function* spawnSaga() {
  yield all([
    takeLatest(actions.CREATE_SPAWN.REQUEST, createSpawn),
    takeLatest(actions.UPDATE_SPAWN.REQUEST, updateSpawn),
    takeLatest(actions.DELETE_SPAWN.REQUEST, deleteSpawn),
    takeLatest(actions.GET_SPAWNS_BY_ORG.REQUEST, getSpawnsByOrg),
    takeLatest(actions.TOGGLE_SPAWN_CONTAMINATION.REQUEST, toggleSpawnContamination),
    takeLatest(actions.TOGGLE_SPAWN_ACTIVE.REQUEST, toggleSpawnActive),
    takeLatest(actions.TOGGLE_SPAWN_DEPLETION.REQUEST, toggleSpawnDepletion),
    takeLatest(actions.GET_SPAWN_DETAIL.REQUEST, getSpawnDetail),
    takeLatest(actions.GET_SPAWN_LINEAGE.REQUEST, getSpawnLineage),
  ]);
}
